import { IconProps } from "../../types/genereal";
import { IconWrapper } from "components/ui/IconWrapper";

export const ThreePeopleIcon = ({
  width = "12",
  height = "12",
  color = "#0860A8",
  opacity = "1",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height} opacity={opacity}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.90019 1.5C6.72093 1.5 7.39022 2.19479 7.39022 3.05135C7.39022 3.90791 6.72289 4.6027 5.90019 4.6027C5.07749 4.6027 4.41016 3.90791 4.41016 3.05135C4.41016 2.19479 5.07749 1.5 5.90019 1.5Z"
          fill={color}
        />
        <path
          d="M2.49794 3.2688C3.14034 3.2688 3.66385 3.81385 3.66385 4.48269C3.66385 5.15153 3.14034 5.69658 2.49794 5.69658C1.85554 5.69658 1.33203 5.15153 1.33203 4.48269C1.33203 3.81385 1.85554 3.2688 2.49794 3.2688Z"
          fill={color}
        />
        <path
          d="M9.29872 3.2688C9.94112 3.2688 10.4646 3.81385 10.4646 4.48269C10.4646 5.15153 9.94112 5.69658 9.29872 5.69658C8.65632 5.69658 8.13281 5.15153 8.13281 4.48269C8.13281 3.81385 8.65632 3.2688 9.29872 3.2688Z"
          fill={color}
        />
        <path
          d="M6.7311 5.55701H5.06471C4.25931 5.55701 3.60352 6.23983 3.60352 7.07833V10.1151C3.60352 10.2369 3.69748 10.3347 3.81446 10.3347H7.97958C8.09655 10.3347 8.19052 10.2369 8.19052 10.1151V7.07833C8.19052 6.23979 7.53469 5.55701 6.72933 5.55701H6.7311Z"
          fill={color}
        />
        <path
          d="M9.90575 6.46533H8.55575C8.54041 6.46533 8.52507 6.46733 8.50781 6.46933C8.56918 6.66099 8.60177 6.86464 8.60177 7.07826V9.89934H10.8358C10.9528 9.89934 11.0467 9.80151 11.0467 9.67972V7.65725C11.0467 7.00039 10.5347 6.46732 9.90574 6.46732L9.90575 6.46533Z"
          fill={color}
        />
        <path
          d="M1.89098 6.46537C1.26201 6.46537 0.75 7.00044 0.75 7.6553V9.67776C0.75 9.79955 0.843962 9.89739 0.960944 9.89739H3.19495V7.07631C3.19495 6.86268 3.22947 6.65904 3.28891 6.46737C3.27357 6.46737 3.25823 6.46338 3.24097 6.46338H1.89097L1.89098 6.46537Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};
